import { ArrowRightIcon, ShoppingCartSimpleIcon, TShirtIcon, UserCircleIcon } from '@phosphor-icons/react'

import {
  fullTextMatchTypes,
  idMatchTypes,
  numericComparisonMatchTypes,
  numericRangeMatchTypes,
} from '@/common/components/MatchTypeEditor/constants'
import { getBaseProductProperties } from '@/common/helpers/rules/helpers'

export const getConditionTypes = ({ productTypes, productCategories, productCollections }) => ({
  order: {
    label: 'Pedido',
    description: 'Evalúa las propiedades del pedido original.',
    icon: ShoppingCartSimpleIcon,
    scope: 'order',
    properties: {
      order_net_value: { label: 'Valor neto del pedido', matchTypes: numericComparisonMatchTypes },
    },
  },
  customer: {
    label: 'Cliente',
    description: 'Evalúa las propiedades del cliente que realizó el pedido.',
    icon: UserCircleIcon,
    scope: 'customer',
    properties: {
      customer_email: { label: 'Email del cliente', matchTypes: fullTextMatchTypes },
      customer_tag: { label: 'Etiqueta del cliente', matchTypes: fullTextMatchTypes },
      customer_group: { label: 'Grupo del cliente', matchTypes: idMatchTypes },
    },
  },
  productInOrder: {
    label: 'Producto en el pedido',
    description:
      'Evalúa las propiedades de los productos del pedido original, incluyendo los productos que no se están devolviendo.',
    icon: TShirtIcon,
    scope: 'item',
    itemContext: 'in_order',
    supportsAppliesWhen: true,
    properties: getBaseProductProperties({ productTypes, productCategories, productCollections }),
  },
  shipment: {
    label: 'Envío',
    description: 'Condiciones basadas en las propiedades del envío resultante.',
    icon: ArrowRightIcon,
    scope: 'shipment',
    properties: {
      shipment_weight: { label: 'Peso del envío', matchTypes: numericRangeMatchTypes },
      shipment_number_of_products: {
        label: 'Número de productos incluidos',
        matchTypes: numericComparisonMatchTypes,
      },
    },
  },
})
